// From Color Palette in Zeplin
const Colors = {
  White: '#ffffff',
  EggShell: '#ffedc2',
  Beige: '#eae1d5',
  Silver: '#ccd9d4',
  Brown: '#8b5e37',
  Hotpink: '#f75496',
  SkyBlue: '#44bffc',
  LightSage: '#e1f3dd',
  LightPeach: '#ffdcc1',
  VeryLightPurple: '#f9e8f7',
  VeryLightBrown: '#d5bc9c',
  LightPeriwinkle: '#d4e4fa',
  LightPeriwinkleTwo: '#ccd9f7',
  LightBlueGreyTwo: '#dbdcf5',
  LightBlueGreyFour: '#d4dee7',
  PinkishGrey: '#dfd4d4',
  PinkishGreyTwo: '#d7d1c9',
  LightGrey: '#e5e5d7',
  LightGreyTwo: '#f0ece2',
  PaleGrey: '#e7f5f8',

  Teal700: '#137679',
  Teal600: '#259295',
  Teal500: '#31a7aa',
  Teal400: '#27b6ba',
  Teal300: '#5ec4c7',
  Teal200: '#99dade',
  Teal100: '#dcf0f3',
  Teal50: '#e9f7f8',

  Blue800: '#154566',
  Blue700: '#184C71',
  Blue600: '#1f5c87',
  Blue500: '#2c6a95',
  Blue400: '#4882ab',
  Blue200: '#96c0dd',
  Blue100: '#deecf6',
  Blue50: '#f1f7fb',

  Green600: '#45a359',
  Green500: '#52b166',
  Green400: '#62c276',
  Green300: '#72d186',
  Green200: '#89dd9b',
  Green100: '#d6f5dd',
  Green50: '#eff8f1',

  Red600: '#c0392c',
  Red500: '#d5493b',
  Red400: '#e95e51',
  Red300: '#ed766b',
  Red200: '#f2938a',
  Red100: '#f8ceca',
  Red50: '#fceeed',

  Amber700: '#F6892D',
  Amber600: '#d97f1a',
  Amber500: '#ed8918',
  Amber400: '#ff941d',
  Amber300: '#FFC866',
  Amber200: '#ffc077',
  Amber100: '#ffdfbb',
  Amber50: '#fff7e9',

  Purple800: '#463888',
  Purple600: '#5f4db0',
  Purple400: '#7e68e5',
  Purple200: '#b2a4ef',
  Purple100: '#d8d1f7',
  Purple50: '#f2effc',

  Gray900: '#0D1017',
  Gray700: '#323742',
  Gray600: '#464c59',
  Gray500: '#696f7a',
  Gray400: '#8d919a',
  Gray300: '#b0b4bb',
  Gray200: '#d4d6db',
  Gray100: '#e6e8ec',
  Gray50: '#eef0f2',

  // New redesign card colors
  BlackNeutral: '#1D222B',
  BrandDefault: '#15A4AD',
}

export default Colors
